module.exports = __webpack_public_path__ + "img/max-file-add--zip.0adef495.svg";